
export class MapFile {
    map: Map<string, string> = new Map();
    url: string = "";
    data?: string;

    keyTranslateFn = (key: string) => key;
    valueTranslateFn = (value: string) => value;

    constructor(filename?: string) {
        if (filename) {
            this.setFile(filename);
        }
    }

    setFile(filename: string) {
        if (!filename.startsWith("http")) {

            // if we run from electron, we have to remove /
            if (window.electron && filename.startsWith('/')) {
                filename = filename.substring(1);
                console.debug('resource path: ', window.electron.resourcePath);
                // filename = window.electron.resourcePath + filename;
            }
        }
        const i = filename.indexOf('?');

        if (i > 0) {
            this.url = filename.substring(0, i);
            this.data = filename.substring(i + 1);
        } else {
            this.url = filename;
            this.data = undefined;
        }
    }

    isSecure() {
        const securePrefix = "https://";

        if (this.url.startsWith("http")) {
            return this.url.startsWith(securePrefix);
        } else {
            // local file, or same origin
            return document.location.href.startsWith(securePrefix);
        }
    }

    async load(filename?: string) {
        if (filename) {
            this.setFile(filename);
        }
        console.log('loading', this.url);

        this.map.clear();

        // The server sends no Cache-Control, so the browser kept the old strings for days by heuristic.
        // no-cache revalidates every load: a 304 when unchanged, the new file after a release.
        const response = await fetch(this.url, { cache: 'no-cache' });

        if (response.ok) {
            console.debug('loaded ', response, this);
            const text = await response.text();

            let bol = 0;
            let eol = text.indexOf('\n');

            while (eol > -1) {
                let s = text.substring(bol, eol);

                if (s.length > 0 && s.charAt(0) != '#') { // # = comment line
                    let key = "";
                    let value = "";
                    let keyfound = false;

                    for (let c of s) {
                        if (!keyfound) {
                            // anything found here is part of key
                            if (c == '=') {
                                keyfound = true;
                            } else {
                                key += c;
                            }
                        } else {
                            value += c;
                        }
                    } // eol

                    if (keyfound && key.length > 0 && value.length > 0) {
                        // found key/value pair
                        // translate special strings like \n
                        value = this.valueTranslateFn(value);
                        key = this.keyTranslateFn(key);
                        // all keys must be stored lower case
                        this.map.set(key, value);
                    }
                }

                bol = eol + 1;
                eol = text.indexOf('\n', bol);

                if (eol < 0) {
                    // maybe file not ending with \n
                    if (bol < text.length) {
                        eol = text.length;
                    }
                }
            }
        } else {
            throw "couldn't get " + filename + ". got code " + response.status;
        }
    }

    get(key: string) {
        key = this.keyTranslateFn(key);
        return this.map.get(key);
    }
}